import { Typography } from '@mui/material'

export const Typo = () => {
  return (
    <div>
        <Typography variant='h1'>Hello World</Typography>
        <Typography variant='h2'>Hello World</Typography>
        <Typography variant='h3'>New World</Typography>
        <Typography variant='h4'>Hello World</Typography>
        <Typography variant='h5'>Hello World</Typography>
        <Typography variant='h6'>Hello World</Typography>
    </div>
  )
}
